import env from "@/app/config/env";
import {
  NotificationAnnouncementItemSchema,
  NotificationAnnouncementItemType,
  NotificationDataSchema,
  NotificationDataType,
} from "@/schemas/index";
import axios, { type AxiosResponse } from "axios";
import { z } from "zod";

export interface ServiceNotificationsApiType {
  fetchNotifications: () => Promise<NotificationDataType>;
  fetchAnnouncements: () => Promise<NotificationAnnouncementItemType[]>;
  deleteAnnouncement: (id: string) => Promise<void>;
}

const NotificationAnnouncementsArraySchema = z.array(
  NotificationAnnouncementItemSchema,
);

export const serviceNotificationsApi: ServiceNotificationsApiType = {
  fetchNotifications: () => {
    return axios
      .get(`${env.services.portal}/notifications`)
      .then((response: AxiosResponse<unknown>) =>
        NotificationDataSchema.parse(response?.data),
      );
  },
  fetchAnnouncements: () => {
    return axios
      .get(`${env.services.portal}/notifications/announcements`)
      .then((response: AxiosResponse<unknown>) =>
        NotificationAnnouncementsArraySchema.parse(response?.data),
      );
  },
  deleteAnnouncement: (id: string) => {
    return axios
      .delete(`${env.services.portal}/notifications/announcements/${id}`)
      .then(() => undefined);
  },
};
